var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoveTo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.03081 12.437C0.746965 12.437 0.504351 12.336 0.302969 12.134C0.10099 11.9326 0 11.69 0 11.4062V8.71709C0 7.44725 0.448179 6.36056 1.34454 5.45703C2.2409 4.5529 3.33147 4.10084 4.61625 4.10084H12.5714L10.1513 1.70308C9.95705 1.50887 9.86383 1.27731 9.8716 1.0084C9.87877 0.739496 9.97946 0.500467 10.1737 0.291316C10.3679 0.0971053 10.6069 0 10.8908 0C11.1746 0 11.4136 0.0971053 11.6078 0.291316L15.7311 4.41457C15.8207 4.51914 15.888 4.63119 15.9328 4.7507C15.9776 4.87021 16 4.9972 16 5.13165C16 5.26611 15.9776 5.39309 15.9328 5.51261C15.888 5.63212 15.8207 5.74416 15.7311 5.84874L11.5854 9.9944C11.3912 10.1886 11.1561 10.2821 10.88 10.275C10.6033 10.2672 10.3679 10.1662 10.1737 9.97199C9.97946 9.77778 9.88235 9.53875 9.88235 9.2549C9.88235 8.97106 9.97946 8.73203 10.1737 8.53782L12.5714 6.16247H4.61625C3.89916 6.16247 3.29053 6.40896 2.79036 6.90196C2.2896 7.39496 2.03922 8 2.03922 8.71709V11.4062C2.03922 11.69 1.94211 11.9326 1.7479 12.134C1.55369 12.336 1.31466 12.437 1.03081 12.437Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveTo);
export default __webpack_public_path__ + "static/media/move-to.91dca97a999f828aa40c6aee936dec24.svg";
export { ForwardRef as ReactComponent };